import { render, staticRenderFns } from "./MobileNavigationItem.vue?vue&type=template&id=08f81d49"
import script from "./MobileNavigationItem.vue?vue&type=script&lang=js"
export * from "./MobileNavigationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports